define('home/templates/channelLeadersModule',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<ul class=\"nav-tabs -small\">\n<li data-action=\"switch-tab\" data-tab=\"leaders\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Top Contributors",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n<li data-action=\"switch-tab\" data-tab=\"mods\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Mods %(numberFollowing)s",{"name":"gettext","hash":{"numberFollowing":helpers.tag.call(alias1,"span",{"name":"tag","hash":{"text":(depth0 != null ? depth0.numMods : depth0),"class":"nav-tab-stat--simple"},"data":data})},"data":data}))
    + "\n</a>\n</li>\n</ul>\n<div data-role=\"leaders-content-area\"></div>\n<div data-role=\"footer\" data-action=\"expand-module\" class=\"aside__expand text-small\">"
    + alias2(helpers.gettext.call(alias1,"See More",{"name":"gettext","hash":{},"data":data}))
    + "</div>\n";
},"useData":true})

});
